import { ConnectedInputField } from '../../Shared/ConnectedInputField';
import { useSendingPlatformsQueryContext } from '../../../../contexts';
import { MAILGUN } from '../../../../constants';
import { ESP_ACCOUNT_PAYLOAD_FIELDS } from '../../../../types';
import { useCreateAccount } from '../../../../hooks';
import { getEspRadioOptionsForSendingPlatform } from '../../../../utils';
import { AccountTypesRadioListField } from '../../Shared/AccountTypesRadioListField';
import { CreateModalRHF } from '../../Shared/CreateModalRHF';

const { ESP, NAME, API_KEY } = ESP_ACCOUNT_PAYLOAD_FIELDS;

export const MailgunCreateModal = () => {
  const { espDefinitions = [] } = useSendingPlatformsQueryContext();
  const { createAccount } = useCreateAccount();

  const espOptions = getEspRadioOptionsForSendingPlatform(MAILGUN, espDefinitions);

  return (
    <CreateModalRHF headerText="Connect MailGun account" onSubmit={createAccount}>
      <ConnectedInputField name={NAME} labelText="Name" data-test="name-input" />
      {espOptions.length > 1 && (
        <AccountTypesRadioListField labelText="Account type" name={ESP} options={espOptions} />
      )}
      <ConnectedInputField name={API_KEY} labelText="API key" data-test="apiKey-input" />
    </CreateModalRHF>
  );
};
